const serviceRouter = {
  path: '',
  component: () => import('@/layout'),
  children: [
    {
      path: '/newFeedback', // 新建工单
      name: 'NewFeedback',
      component: () => import(/* webpackChunkName: "service" */ '@/pages/newFeedback/index'),
      redirect: 'newFeedback/index',
      children: [
        {
          path: 'index',
          name: 'NewFeedbackNew',
          meta: { title: '新建工单' },
          component: () => import(/* webpackChunkName: "service" */ '@/pages/newFeedback/new')
        },
        {
          path: 'success',
          name: 'NewFeedbackSuccess',
          meta: { title: '工单创建成果' },
          component: () => import(/* webpackChunkName: "service" */ '@/pages/newFeedback/success')
        }
      ]
    }
  ]
}

export default serviceRouter
